module.exports = __webpack_public_path__ + "img/Wp_2048.352f0cbc.png";